import { MiddlewareType } from './types';

export const authMiddleware =
    (graphqlToken: string): MiddlewareType =>
    async (args, next) => {
        const { context } = args;
        if (context.request) {
            context.request.headers = {
                ...context.request.headers,
                Authorization: `Bearer ${graphqlToken}`,
            };
        }
        return next(args);
    };
